"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestHandler = void 0;
var siteAssetsClientErrors_1 = require("./domain/siteAssetsClientErrors");
exports.RequestHandler = function (config, urlBuilder, clientModuleExecutor, moduleResultExtractor, buildHttpClientAdapter, buildModuleMetricsReporter, siteAssetsServerHttpHandlerBuilder) { return function (request) {
    var moduleMetricsReporter = buildModuleMetricsReporter(request.module);
    var httpClientAdapter = buildHttpClientAdapter(moduleMetricsReporter);
    var toSiteAssetsResponse = function (moduleResult) { return ({
        result: function () { return moduleResult; }
    }); };
    var runClientModuleExecutor = function (siteAssetsServerError) {
        return clientModuleExecutor
            .execute(request)
            .catch(function (moduleExecutorError) {
            moduleMetricsReporter.reportError(moduleExecutorError);
            return Promise.reject(new siteAssetsClientErrors_1.SiteAssetsFallbackError(moduleExecutorError, siteAssetsServerError));
        });
    };
    var executeModuleOnClient = function (siteAssetsServerError) {
        return moduleMetricsReporter.runAsyncAndReport(function () { return runClientModuleExecutor(siteAssetsServerError); }, 'execute-fallback');
    };
    var attemptFallback = function (siteAssetsUrl, httpRequestError) {
        var siteAssetsServerError = new siteAssetsClientErrors_1.SiteAssetsServerError(siteAssetsUrl, httpRequestError);
        if (request.fallbackStrategy == 'enable') {
            return executeModuleOnClient(siteAssetsServerError);
        }
        return Promise.reject(siteAssetsServerError);
    };
    var executeModuleOnServer = function () {
        var siteAssetsUrl;
        try {
            siteAssetsUrl = urlBuilder.siteAssetsUrl(request, config.siteAssetsTopology.baseDomain);
        }
        catch (urlBuilderError) {
            return Promise.reject(new siteAssetsClientErrors_1.UrlBuilderError(urlBuilderError));
        }
        var siteAssetsServerHttpHandler = siteAssetsServerHttpHandlerBuilder.build(siteAssetsUrl);
        return httpClientAdapter.call(siteAssetsServerHttpHandler)
            .then(moduleResultExtractor.moduleResult)
            .catch(function (httpRequestError) { return attemptFallback(siteAssetsUrl, httpRequestError); });
    };
    var executeModule = function () {
        if (request.fallbackStrategy == 'force') {
            return executeModuleOnClient();
        }
        return executeModuleOnServer();
    };
    var execute = function () {
        return moduleMetricsReporter.runAsyncAndReport(function () { return executeModule().then(toSiteAssetsResponse); }, 'execute');
    };
    return {
        execute: execute
    };
}; };
